import { Component, Input, OnInit } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-details-person',
  templateUrl: './entity-details-person.component.html'
})

export class EntityDetailsPersonComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Person';

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/entitydetailsperson/entity-details-person.component.ts